<template>
  <div class="grid grid-cols-12 gap-4">
    <div class="col-span-12">
      <form>
        <div class="grid grid-cols-12 gap-4 mx-auto">
          <div class="col-span-12">
            <input
              type="text"
              class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent my-2"
              v-model="form.name"
              placeholder="Group Name"
              required
            />
            <textarea
              class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent my-2"
              v-model="form.description"
              placeholder="Description"
              rows="4"
            ></textarea>
            <button class="btn-primary bg-primary text-white px-2 py-1 rounded-sm hover:bg-primary-dark" type="button" @click="submitGroup">
              Save Group
              <span class="lds-ring" v-if="spinner">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
              </span>
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, watch, onMounted } from 'vue'
import { useStore } from 'vuex'

interface GroupForm {
  name: string | null
  description: string | null
}

interface Group {
  id: string
  name: string
}

const store = useStore()

const errorMessage = ref<string | null>(null)
const checkPermissions = ref(false)
const form = ref<GroupForm>({
  name: null,
  description: null
})
const groupData = ref<Group[]>([])
const spinner = ref(false)
const role_uid = ref<string | null>(null)
const permissionGroups = ref<Group[]>([])

onMounted(() => {
  errorMessage.value = ""
  store.dispatch("fetchPermissionGroups")
})

const submitGroup = () => {
  spinner.value = true
  errorMessage.value = null

  let data = {
    description: form.value.description,
    name: form.value.name,
    enabled: true
  }
  store.dispatch("addPermissionGroup", data)
}

// Watchers
watch(() => store.getters.getPermissionGroupsList, (rolesGroup) => {
  if (rolesGroup) {
    groupData.value = rolesGroup
  }
})

watch(() => store.getters.getNewPermissionGroup, (data) => {
  if (data) {
    spinner.value = false
    // @ts-ignore
    successToast("Success", "Group added successfully")
    groupData.value = []
    store.dispatch("fetchPermissionGroups")
  }
})

watch(() => store.getters.getRolesError, (rolesError) => {
  if (rolesError) {
    spinner.value = false
    errorMessage.value = rolesError.message
    // @ts-ignore
    errorToast("Error", rolesError.message)
  }
})
</script>
